import camelcase from 'camelcase';

import { type GetUser } from '@api/user/types';
import { RoleCodes } from '@models/User/permissions/permissionsRoleModel/helpers/types';

import { type User } from './types';

/**
 * Model to transform user data from API
 */
export const userModel = ({
  id,
  firstName,
  lastName,
  email,
  account,
  initials,
  isActive,
  isAssigned,
  isVatglobal,
  role,
}: GetUser): User => ({
  id,
  firstName: firstName ?? '',
  lastName: lastName ?? '',
  email,
  account: account ?? '',
  initials: initials ?? '',
  isActive: isActive ?? false,
  isAssigned: isAssigned ?? false,
  isMspAccount: isVatglobal ?? false,
  role: camelcase(role || '') as RoleCodes,
});
